import { render, staticRenderFns } from "./index-head.vue?vue&type=template&id=3871d394&"
import script from "./index-head.vue?vue&type=script&lang=js&"
export * from "./index-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports